<related-feature-form *ngIf="displayRelatedTable" #relatedFeatureFormRef [relatedFeatureParams]="relatedFeatureParams">
</related-feature-form>
<div class="col-12" *ngIf="!displayRelatedTable">
  <p class="messag-format font-weight-bold" translate>JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.NO_NUTZUNGSSICHT</p>
</div>

